import { NgModule } from '@angular/core';
import { IonWrapperComponent } from './ion-wrapper';

@NgModule({
  declarations: [
    IonWrapperComponent
  ],
  exports: [
    IonWrapperComponent
  ]
})
export class IonWrapperModule {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/ion-wrapper.module.ts